import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MenuManageTabProps } from '@type/productType';
import { bizStorage } from '@library/bizStorage';
import { StorageStoreListType } from '@type/storageType';
import { StoreStatusKo } from '@type/pointType';
import { MenuManage, MenuOrder, OptionManage, Origin, Recommend } from '@src/pages/product/componnents';
import Spinner from '@components/molecules/Spinner';
import { TAB_LIST } from '@src/constants/product';
import { useMenuPermission } from '@src/recoil/permission';
import { useSetRecoilState } from 'recoil';
import { categoryId, optGroupId, menuOrderGategoryId, menuScroll } from '@src/recoil/menu';
import ScrollTopBtn from '@src/components/molecules/ScrollTopBtn';

const MenuProduct = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const storeList = bizStorage.getItem<StorageStoreListType>('storeList');
  const tab = searchParams.get('tab') || 'menu';
  const storeID = searchParams.get('storeID');

  const [loading, setLoading] = useState<boolean>(false);
  const { isAuthLoading } = useMenuPermission(storeID);

  const setCategoryId = useSetRecoilState(categoryId);
  const setOptGroupId = useSetRecoilState(optGroupId);
  const setMenuOrderGategoryId = useSetRecoilState(menuOrderGategoryId);
  const setMenuScrollValue = useSetRecoilState(menuScroll);

  const handleStoreChange = (id: string) => {
    if (id === storeID) return;
    setMenuScrollValue({
      depth1: 0,
      depth2: 0,
    });
    setSearchParams(
      (prevParams) => {
        const tab = prevParams.get('tab');
        return { tab, storeID: id };
      },
      { replace: true },
    );
  };

  const handleTab = (e: React.MouseEvent<HTMLButtonElement>) => {
    setMenuScrollValue({
      depth1: 0,
      depth2: 0,
    });
    const { value } = e.currentTarget;
    setSearchParams((prevParams) => {
      const storeID = prevParams.get('storeID');
      return { tab: value, storeID };
    });
    setCategoryId('');
    setOptGroupId('');
    setMenuOrderGategoryId({ id: '', type: '', title: '' });
  };

  useEffect(() => {
    if (!storeList) return;
    if (storeID) {
      handleStoreChange(storeID);
    } else {
      setSearchParams({ tab, storeID: storeList[0].ID }, { replace: true });
    }
  }, [storeID]);

  const TabComponent = () => {
    const tabComponents: Record<string, React.FC<MenuManageTabProps>> = {
      menu: MenuManage,
      option: OptionManage,
      order: MenuOrder,
      recommend: Recommend,
      origin: Origin,
    };

    const Component = tabComponents[tab] || MenuManage;
    return <Component storeId={storeID} setLoading={setLoading} />;
  };

  return (
    <div className="menu-manage">
      <aside id="mAside">
        <div className="download-select">
          <select onChange={(e) => handleStoreChange(e.target.value)} value={storeID || ''}>
            {storeList &&
              storeList.map((v, idx) => {
                const { ID, name, status } = v;
                return (
                  <option key={`${ID}-${idx}`} value={ID} data-name={name}>
                    [{StoreStatusKo[Number(status)]}] [{ID}] {name}
                  </option>
                );
              })}
          </select>
        </div>
      </aside>
      <div className="tab-scroll sticky">
        <ul className="menu-tab">
          {TAB_LIST?.map((list) => {
            const { value, title } = list;
            return (
              <li key={value}>
                <button type="button" value={value} className="link-tab" onClick={handleTab}>
                  <span className={`txt-tab ${tab === value ? 'selected' : ''}`}>{title}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <section className="sec-product">{TabComponent()}</section>
      <Spinner show={loading || isAuthLoading} />
      {tab !== 'origin' && <ScrollTopBtn />}
    </div>
  );
};

export default MenuProduct;
